import { API_PATHS } from "../constants/api-paths";
import { COMMON_SSO_MOBILE } from "../constants/sso";
import { decryptLocalStorageMobileNo } from "@repo/shared-utils/crypto";
import { getSessionData, getCookie } from "@repo/shared-utils/common-utils";
import { IResponse, encryptedRequest } from "../core/api.client";

export interface IApiResponseConsentRead {
  data: Record<string, null>;
  statusCode: number;
  status: string;
  message: string;
}

export interface IApiResponseConsentInsert {
  data: Record<string, unknown> | null;
  statusCode: number;
  status: string;
  message: string;
}

const consentRead = async (
  partnerName: string,
  partnerId: string,
  consentCategory: string
): Promise<IResponse<Record<string, unknown>>> => {
  try {
    const p_token = getCookie("p_token");
    const localStorageMobileNo = localStorage.getItem(COMMON_SSO_MOBILE);
    const mobileNumFromSession = await decryptLocalStorageMobileNo(localStorageMobileNo || "");

    // Return early if no mobile number available
    if (!mobileNumFromSession) {
      return {} as IResponse<Record<string, unknown>>;
    }

    const response = await encryptedRequest<Record<string, undefined>>({
      method: "POST",
      url: API_PATHS.consentRead,
      data: {
        p_token,
        mobileNo: mobileNumFromSession,
        partnerName: partnerName ?? "",
        partnerId: partnerId ?? "",
        consentCategory: consentCategory ?? "",
      },
    });
    if ([90, 91, 92].includes(response?.statusCode)) {
      return response;
    }
    return {} as IResponse<Record<string, unknown>>;
  } catch (err) {
    console.error("Error in consent-read API", err);
    throw err;
  }
};

const consentInsert = async (
  partnerName: string,
  consentCategory: string,
  consentStatus: boolean
): Promise<IResponse<Record<string, unknown>>> => {
  try {
    const p_token = getCookie("p_token");
    const localStorageMobileNo = localStorage.getItem(COMMON_SSO_MOBILE);
    const mobileNumFromSession = await decryptLocalStorageMobileNo(localStorageMobileNo || "");
    const { custId, custType, firstName, lastName } = await getSessionData();

    const custIdFromSession = custId ?? "";
    const firstNameSession = firstName ?? "";
    const lastNameSession = lastName ?? "";
    const custTypeSession = custType ?? "";

    const response = await encryptedRequest<Record<string, unknown>>({
      method: "POST",
      url: API_PATHS.consentInsert,
      data: {
        p_token,
        mobileNo: mobileNumFromSession,
        partnerName: partnerName ?? "",
        consentCategory: consentCategory ?? "",
        consentStatus,
        custId: custIdFromSession,
        ...(custTypeSession === "ETB"
          ? { firstName: firstNameSession, lastName: lastNameSession }
          : {}),
      },
    });
    if ([90, 91, 92].includes(response?.statusCode)) {
      return response;
    }
  } catch (err) {
    console.error("Error in consent-insert API", err);
    throw err;
  }
  return {} as IResponse<Record<string, unknown>>;
};

export { consentRead, consentInsert };
